module.exports = __webpack_public_path__ + "assets/images/cosmote_8.e854c493c9cbf75ec8640b162b654f75.png";